import { css } from "@emotion/react";
import { defaultPageLayout } from "../../styles/mixins";
import SideBarNav from "../../components/displays/SideBarNav";
import useAuth from "../../components/hooks/useAuth";
import React from "react";
import HeaderNav from "../../components/displays/HeaderNav";
import { UserRole } from "@monorepo/api-types";
import CircularProgress from "@mui/material/CircularProgress";
import ErrorMessage from "apps/survey-client/components/displays/ErrorMessage";
import HubMainPage from "../../components/displays/Hub/MainPage";
import { useRecoilValue } from "recoil";
import { hubAtom } from "../../atoms/hub.atom";

const s = {
  container: defaultPageLayout,
  itemInColumn: css({
    marginBottom: "2.6rem",
  }),
  hubContainer: css({
    padding: "2.4rem",
    borderRadius: 8,
    backgroundColor: "white",
  }),
};

export const ResourcePage = () => {
  useAuth([UserRole.FULL_VIEW_ACCESS, UserRole.DEI_LEAD]);
  const { data, requestState } = useRecoilValue(hubAtom);

  return (
    <div css={s.container}>
      <SideBarNav />
      <HeaderNav />
      <h1 css={s.itemInColumn}>Your DEI hub</h1>

      <div css={s.hubContainer}>
        {requestState.state === "loading" && (
          <div css={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress size={25} />
          </div>
        )}
        {requestState.state === "error" && (
          <ErrorMessage message={requestState.message} />
        )}
        {requestState.state === "success" && data && <HubMainPage {...data} />}
      </div>
    </div>
  );
};

export default ResourcePage;
